module.exports = __webpack_public_path__ + "static/media/galerija_2016 (5).007857fa.jpg";